import { Injectable } from '@angular/core';
import { Observable, of, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../model/user';
import { OneIdClient } from 'src/NSwag/nswag-api-auth';
@Injectable({ providedIn: 'root' })
export class UserService
{
  private _user: ReplaySubject<User> = new ReplaySubject<User>(1);
  private _userValue: User | undefined;
  private _isCurrentUserDataDownloaded: boolean = false;

  constructor(
    private oneidClient: OneIdClient,
  )
  {
    this._user.subscribe(u =>
    {
      this._userValue = u;
    });
  }

  set user(value: User)
  {
    this._user.next(value);
  }

  get user$(): Observable<User>
  {
    return this._user.asObservable();
  }
  get currentUser$(): Observable<User>
  {
    return this._isCurrentUserDataDownloaded
      ? this._user.asObservable()
      : this.get();
  }

  get(): Observable<User>
  {
    return this.oneidClient.getUserProfile().pipe(
      map(userProfile =>
      {
        this._isCurrentUserDataDownloaded = true;
        let user = Object.assign(new User(), userProfile);
        user.status = 'online';
        this.user = user;
        return user;
      })
    );
  }

  /**
   * Possible To Update User In Back-end
   */
  update(user: User): Observable<any>
  {
    return of('');
  }
}
